import { MotifFormField, MotifLabel, MotifTextArea } from "@ey-xd/motif-react";
interface TextAreaProps {
    ariaLabel?: string | undefined;
    label?: string | undefined;
    onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
    value: string;
    prefix?: string | undefined | null;
    readonly?: boolean;
    hideClearButton?: boolean;
    name?: string;
    error? : {
        isError: boolean;
        message: string;
    }
    placeholder?: string;
}

const TextArea: React.FC<TextAreaProps> = ({ariaLabel="", label="", name="", onChange, value, prefix = "", readonly=false, hideClearButton=false, error={
    isError: false,
    message: ''
}, placeholder=""} ) => {
    const { isError } = error;
    return (
    <>
    <MotifFormField
        aria-label="Label"
        role="group"
        >
        <MotifLabel aria-label="Label">
            {label}{' '}
        </MotifLabel>
        <MotifTextArea
            aria-label="Label"
            ariaLabel={ariaLabel}
            label={label}
            onChange={onChange}
            value={value}
            prefix={prefix}
            disabled={readonly}
            hideClearButton={hideClearButton}
            name={name}
            className={ isError ? 'motif-input-invalid' : ''}
            error={isError}
            placeholder={placeholder}
        />
    </MotifFormField>
    </>
    );
};

export default TextArea;
  